// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"styles_textBlock__K1xo9","editMode":"styles_editMode__3CM-W","text":"styles_text__Pb_kO"};